import React, { Fragment } from "react";
import { connect, Provider } from "react-redux";
import autoBind from "auto-bind";
import { createStore, applyMiddleware } from "redux";
import { thunk } from "redux-thunk";

import BaseComponent from "@js/components/base_component.jsx";
import LoadingSpinner from "@js/components/studio/utilities/loading_spinner.jsx";

import { studioOpensOverviewByPrivacy } from "@js/actions/studio/stats/studio_opens_overview_by_privacy.js";

class StudioOpensOverviewByPrivacyTable extends BaseComponent {

  componentDidMount() {
    this.props.dispatch(studioOpensOverviewByPrivacy(this.props.stat_or_slice_id));
  }

  componentDidUpdate() {
    if ( this.props.loaded ) {
      const count = this._formatInt(this.props.summary.privacy_protection.nonprivacy_subscribers.nonprivacy_opens_unique);
      const rate  = this._formatRate(this.props.summary.privacy_protection.nonprivacy_subscribers.nonprivacy_opens_unique_rate, 2);
      const total = this._formatInt(this.props.summary.privacy_protection.nonprivacy_subscribers.nonprivacy_opens_total);

      $("#opens-nonprivacy-unique-count").text(count);
      $("#opens-nonprivacy-unique-rate").text(rate);
      $("#opens-nonprivacy-total-count").text(total);
    }
  }

  render() {
    if ( this.props.loading ) {
      return (
        <LoadingSpinner width="32" height="32" />
      );
    }

    if ( !this.props.loaded ) {
      return null;
    }

    return (
      <table border="0" cellPadding="0" cellSpacing="0" width="100%" className="data-table reduced-y-padding">
        <thead>
          <tr className="zebra-odd">
            <td rowSpan="2" width="350px"></td>
            <td className="center" colSpan="2">Unique opens</td>
            <td className="center" colSpan="2">Total opens</td>
            <td className="center" rowSpan="2">Subscribers</td>
          </tr>
          <tr className="zebra-odd">
            <td className="center">Non-privacy</td>
            <td className="center">Privacy</td>
            <td className="center">Non-privacy</td>
            <td className="center">Privacy</td>
          </tr>
        </thead>
        <tbody>
          <tr className="zebra-even">
            <td className="" rowSpan="2">
              <b>All subscribers</b>
              <br/>
              <small>Statistics for all subscribers, regardless of whether or not they use privacy features.</small>
            </td>
            <td className="center rb" colSpan="2">
              {/*<!-- all subscribers: unique opens -->*/}
              { this._renderAllSubscribersUniqueOpensAll() }
            </td>
            <td className="center rb" colSpan="2">
              {/*<!-- all subscribers: total opens -->*/}
              { this._renderAllSubscribersTotalOpensAll() }
            </td>
            <td className="center" rowSpan="2">
              {/*<!-- all subscribers: subscriber count -->*/}
              { this._renderAllSubscribersSubscriberCount() }
            </td>
          </tr>
          <tr className="zebra-even">
            <td className="center">
              {/*<!-- all subscribers: unique opens: non-privacy -->*/}
              { this._renderAllSubscribersUniqueOpensNonPrivacy() }
            </td>
            <td className="center rb">
              {/*<!-- all subscribers: unique opens: privacy -->*/}
              { this._renderAllSubscribersUniqueOpensPrivacy() }
            </td>
            <td className="center">
              {/*<!-- all subscribers: total opens: non-privacy -->*/}
              { this._renderAllSubscribersTotalOpensNonPrivacy() }
            </td>
            <td className="center rb">
              {/*<!-- all subscribers: total opens: privacy -->*/}
              { this._renderAllSubscribersTotalOpensPrivacy() }
            </td>
          </tr>
          <tr className="zebra-odd">
            <td className="">
              <b>Subscribers using privacy features</b>
              <br/>
              <small>Statistics for subscribers that use privacy features such as iCloud+ Private Relay or Mail Privacy Protection.</small>
            </td>
            <td className="center">
              {/*<!-- privacy subscribers: unique opens: non-privacy -->*/}
              { this._renderPrivacySubscribersUniqueOpensNonPrivacy() }
            </td>
            <td className="center rb">
              {/*<!-- privacy subscribers: unique opens: privacy -->*/}
              { this._renderPrivacySubscribersUniqueOpensPrivacy() }
            </td>
            <td className="center">
              {/*<!-- privacy subscribers: total opens: non-privacy -->*/}
              { this._renderPrivacySubscribersTotalOpensNonPrivacy() }
            </td>
            <td className="center rb">
              {/*<!-- privacy subscribers: total opens: privacy -->*/}
              { this._renderPrivacySubscribersTotalOpensPrivacy() }
            </td>
            <td className="center">
              {/*<!-- privacy subscribers: subscriber count -->*/}
              { this._renderPrivacySubscribersSubscriberCount() }
            </td>
          </tr>
          <tr className="zebra-even">
            <td className="">
              <b>Subscribers not using privacy features</b>
              <br/>
              <small>Statistics for subscribers that were not detected to be using privacy features. These statistics are the closest to "traditional" statistics before privacy features became commonplace.</small>
            </td>
            <td className="center">
              {/*<!-- non-privacy subscribers: unique opens: non-privacy -->*/}
              { this._renderNonPrivacySubscribersUniqueOpensNonPrivacy() }
            </td>
            <td className="center rb">
              {/*<!-- non-privacy subscribers: unique opens: privacy -->*/}
              &mdash;
            </td>
            <td className="center">
              {/*<!-- non-privacy subscribers: total opens: non-privacy -->*/}
              { this._renderNonPrivacySubscribersTotalOpensNonPrivacy() }
            </td>
            <td className="center rb">
              {/*<!-- non-privacy subscribers: total opens: privacy -->*/}
              &mdash;
            </td>
            <td className="center">
              {/*<!-- non-privacy subscribers: subscriber count -->*/}
              { this._renderNonPrivacySubscribersSubscriberCount() }
            </td>
          </tr>
        </tbody>
      </table>
    );
  }

  _renderAllSubscribersUniqueOpensAll() {
    const count = this._formatInt(this.props.summary.privacy_protection.all_subscribers.opens_unique);
    const rate  = this._formatRate(this.props.summary.privacy_protection.all_subscribers.opens_unique_rate);
    return <div>
      { count }&nbsp;({ rate })
      <br/>
      <small>(All unique opens)</small>
    </div>;
    return `${ count } (${ rate })`;
  }

  _renderAllSubscribersTotalOpensAll() {
    const count = this._formatInt(this.props.summary.privacy_protection.all_subscribers.opens_total);
    return <div>
      { count }
      <br/>
      <small>(All opens)</small>
    </div>;
  }

  _renderAllSubscribersSubscriberCount() {
    const count = this._formatInt(this.props.summary.privacy_protection.all_subscribers.subscriber_count);
    return <div>
      { count }
    </div>;
  }

  _renderAllSubscribersUniqueOpensNonPrivacy() {
    const count = this._formatInt(this.props.summary.privacy_protection.all_subscribers.nonprivacy_opens_unique);
    const rate  = this._formatRate(this.props.summary.privacy_protection.all_subscribers.nonprivacy_opens_unique_rate);
    return <div>
      { count }&nbsp;({ rate })
    </div>;
  }

  _renderAllSubscribersUniqueOpensPrivacy() {
    const count = this._formatInt(this.props.summary.privacy_protection.all_subscribers.privacy_opens_unique);
    const rate  = this._formatRate(this.props.summary.privacy_protection.all_subscribers.privacy_opens_unique_rate);
    return <div>
      { count }&nbsp;({ rate })
    </div>;
  }

  _renderAllSubscribersTotalOpensNonPrivacy() {
    const count = this._formatInt(this.props.summary.privacy_protection.all_subscribers.nonprivacy_opens_total);
    return <div>
      { count }
    </div>;
  }

  _renderAllSubscribersTotalOpensPrivacy() {
    const count = this._formatInt(this.props.summary.privacy_protection.all_subscribers.privacy_opens_total);
    return <div>
      { count }
    </div>;
  }

  _renderPrivacySubscribersUniqueOpensNonPrivacy() {
    const count = this._formatInt(this.props.summary.privacy_protection.privacy_subscribers.nonprivacy_opens_unique);
    const rate  = this._formatRate(this.props.summary.privacy_protection.privacy_subscribers.nonprivacy_opens_unique_rate);
    return <div>
      { count }&nbsp;({ rate })
    </div>;
  }

  _renderPrivacySubscribersUniqueOpensPrivacy() {
    const count = this._formatInt(this.props.summary.privacy_protection.privacy_subscribers.privacy_opens_unique);
    const rate  = this._formatRate(this.props.summary.privacy_protection.privacy_subscribers.privacy_opens_unique_rate);
    return <div>
      { count }&nbsp;({ rate })
    </div>;
  }

  _renderPrivacySubscribersTotalOpensNonPrivacy() {
    const count = this._formatInt(this.props.summary.privacy_protection.privacy_subscribers.nonprivacy_opens_total);
    return <div>
      { count }
    </div>;
  }

  _renderPrivacySubscribersTotalOpensPrivacy() {
    const count = this._formatInt(this.props.summary.privacy_protection.privacy_subscribers.privacy_opens_total);
    return <div>
      { count }
    </div>;
  }

  _renderPrivacySubscribersSubscriberCount() {
    const count = this._formatInt(this.props.summary.privacy_protection.privacy_subscribers.subscriber_count);
    return <div>
      { count }
    </div>;
  }

  _renderNonPrivacySubscribersUniqueOpensNonPrivacy() {
    const count = this._formatInt(this.props.summary.privacy_protection.nonprivacy_subscribers.nonprivacy_opens_unique);
    const rate  = this._formatRate(this.props.summary.privacy_protection.nonprivacy_subscribers.nonprivacy_opens_unique_rate);
    return <div>
      <b>{ count }&nbsp;({ rate })</b>
    </div>;
  }

  _renderNonPrivacySubscribersTotalOpensNonPrivacy() {
    const count = this._formatInt(this.props.summary.privacy_protection.nonprivacy_subscribers.nonprivacy_opens_total);
    return <div>
      { count }
    </div>;
  }

  _renderNonPrivacySubscribersSubscriberCount() {
    const count = this._formatInt(this.props.summary.privacy_protection.nonprivacy_subscribers.subscriber_count);
    return <div>
      { count }
    </div>;
  }

  _formatInt(value) {
    return `${ value.toLocaleString("en-US") }`;
  }

  _formatRate(rate, precision) {
    if ( typeof(precision) === "undefined" ) precision = 1;

    return `${ ( 100.0 * rate ).toFixed(precision) }%`;
  }

}

const mapStateToProps = (state) => ({
  stat_or_slice_id: state.stat_or_slice_id,
  loading:          state.loading,
  loaded:           state.loaded,
  summary:          state.summary,
});

export default connect(mapStateToProps)(StudioOpensOverviewByPrivacyTable);
